"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const formatFieldDataListItem_1 = require("./formatFieldDataListItem");
exports.formatFieldData = (type, data, { fieldSchema, schema, initialData }, options) => {
    const nextData = formatFieldDataListItem_1.formatFieldDataListItem(type, data, { fieldSchema, schema, initialData }, options);
    return nextData
        ? {
            [nextData.type]: nextData.data,
        }
        : null;
};
//# sourceMappingURL=formatFieldData.js.map